<template>
  <v-app>
    <notify/>
    <v-content class="layout--full-page">
      <div class="header--full-page d-flex align-center px-5"
           style="width: 100%">
        <img src="@/assets/it-logo.svg" style="max-width:150px; padding:10px;"/>
        <v-spacer/>
        <div class="justify-end">
          <lang-switcher/>
        </div>
      </div>
      <v-container>
        <dr-layout-placeholder :model="{$ID:'pl4'+this.routeName, Name:'Main'}"></dr-layout-placeholder>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import Notify from '@/components/Notify'
import LangSwitcher from '@/components/LangSwitcher'

export default {
  name: 'FullPageLayoutOld',
  components: {
    Notify,
    LangSwitcher
  },
  computed: {
    routeName() {
      return this.$route.name
    },
  }
}
</script>

<style scoped>
  .layout--full-page {
    background: url(../assets/full-page-bg.svg) center bottom/cover no-repeat;
  }

  .header--full-page {
    position: fixed;
  }
</style>
